<div id="loaderDiv" class="showLoader" #loaderDiv>
    <div class="loader"></div>
</div>

<app-toolbar></app-toolbar>

<div class="router">
    <router-outlet></router-outlet>
</div>
